import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { filterDefined } from '@core/common-legacy';
import { TellentCurrentUserSelectors } from '@core/tellent-data';
import { TellentMember } from '@core/tellent-types';

export abstract class ChurnFlowProductsBaseService {
  private readonly store = inject(Store);
  private readonly currentMembership = this.store.select(
    TellentCurrentUserSelectors.currentOrganizationMembershipSelector,
  );

  public abstract isWhatsAppHiringActive: Signal<boolean | undefined>;
  public abstract areJourneysActive: Signal<boolean | undefined>;

  public isTellentHrActive: Signal<boolean | undefined> = toSignal(
    this.currentMembership.pipe(
      filterDefined,
      map((membership: TellentMember) =>
        membership.seats.some(seat => seat.app.kind === 'core_hr'),
      ),
    ),
  );

  public isGrowActive: Signal<boolean | undefined> = toSignal(
    this.currentMembership.pipe(
      filterDefined,
      map((membership: TellentMember) =>
        membership.org.features.some(feature => feature === 'grow'),
      ),
    ),
  );
}
